var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconJcb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60.184,
    height: 45.169,
    viewBox: "0 0 60.184 45.169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -575.105,
    y1: 2238.696,
    x2: -574.874,
    y2: 2238.696,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00863f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40a637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5cb431"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -198.358,
    y1: 197.527,
    x2: -198.279,
    y2: 197.527,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -627.788,
    y1: 2444.042,
    x2: -627.535,
    y2: 2444.042,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -196.297,
    y1: 197.711,
    x2: -196.216,
    y2: 197.711,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f286f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#004e93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#0066b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006fbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -197.33,
    y1: 197.347,
    x2: -197.251,
    y2: 197.347,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c2c2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#872730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#bd1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#db0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e50039"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(-3688.032 -4521.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M3733.366,4548.77h4.343c.124,0,.414-.041.538-.041a1.939,1.939,0,0,0,1.531-1.944,2.009,2.009,0,0,0-1.531-1.944,2.154,2.154,0,0,0-.538-.042h-4.343Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M3737.213,4521.346a7.529,7.529,0,0,0-7.528,7.529v7.817h10.63a4.2,4.2,0,0,1,.745.042c2.4.124,4.177,1.365,4.177,3.515,0,1.7-1.2,3.144-3.433,3.434v.082c2.441.166,4.3,1.531,4.3,3.64,0,2.275-2.068,3.764-4.8,3.764h-11.664v15.305h11.044a7.53,7.53,0,0,0,7.528-7.528v-37.6Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M3739.24,4540.746a1.76,1.76,0,0,0-1.531-1.779c-.082,0-.289-.041-.413-.041h-3.93v3.64h3.93a1.132,1.132,0,0,0,.413-.042,1.759,1.759,0,0,0,1.531-1.778Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M3695.6,4521.346a7.529,7.529,0,0,0-7.528,7.529v18.572a14.881,14.881,0,0,0,6.494,1.7c2.6,0,4.012-1.571,4.012-3.722v-8.769h6.452v8.727c0,3.392-2.109,6.164-9.265,6.164a31.732,31.732,0,0,1-7.735-.952v15.842h11.044a7.529,7.529,0,0,0,7.528-7.528v-37.558Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M3716.407,4521.346a7.529,7.529,0,0,0-7.528,7.529v9.844c1.9-1.613,5.212-2.647,10.548-2.4a33.552,33.552,0,0,1,5.915.91v3.185a14.33,14.33,0,0,0-5.708-1.655c-4.054-.289-6.494,1.7-6.494,5.171,0,3.516,2.44,5.5,6.494,5.17a15.03,15.03,0,0,0,5.708-1.654v3.185a32.859,32.859,0,0,1-5.915.91c-5.336.248-8.645-.786-10.548-2.4v17.373h11.044a7.528,7.528,0,0,0,7.528-7.528v-37.641Z",
    fill: "url(#linear-gradient-5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJcb);
export default __webpack_public_path__ + "static/media/iconJCB.f2d055283484083b2aa9378d5b30d69d.svg";
export { ForwardRef as ReactComponent };